import React from 'react';
import styled from 'styled-components';

import { Tabs, Tab } from '@material-ui/core/';

import ImageScalecube from '../../../assets/scalecube.png';

const Root = styled.div`
	img {
		max-width: 100%;
		height: auto;
	}

	ul {
		li {
			margin-top: 20px;
		}
	}
`;

export function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`tabpanel-${index}`}
			aria-labelledby={`tab-${index}`}
			{...other}
		>
			{value === index && <>{children}</>}
		</div>
	);
}

const ContentStoragePark = () => {
	const [value, setValue] = React.useState(0);
	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	return (
		<Root>
			<Tabs value={value} onChange={handleChange} variant="fullWidth">
				<Tab label="Abbildung" />
				<Tab label="Informationen" />
			</Tabs>
			<TabPanel value={value} index={0}>
				<img src={ImageScalecube} alt="scalecube" />
			</TabPanel>
			<TabPanel value={value} index={1}>
				<ul>
					<li>
						<strong>Modular & individuell projektiert</strong>
						<br />
						Modularer Aufbau für verschiedene Kapazitäten, Spannungsebenen,
						Energieinhalte und Leistungen.
					</li>
					<li>
						<strong>All-In-One-Lösung</strong>
						<br />
						Komplettlösung bestehend aus Batteriesystemen und Peripherie,
						inklusive Projektmanagement von der Planung bis zur Abnahme.
					</li>
					<li>
						<strong>Innovatives Racksystem</strong>
						<br />
						Auch auf besonders kleinen Flächen kann ein Höchstmaß an
						gespeicherter Leistung realisiert werden.
					</li>
					<li>
						<strong>Intelligentes Energiemanagementsystem</strong>
						<br />
						Steuerung, Visualisierung und Einbindung des Batteriesystems in
						Ihre Gesamtanlage.
					</li>
				</ul>
			</TabPanel>
		</Root>
	);
};

export default ContentStoragePark;
